import React, { useState } from "react";
import { format } from "date-fns";
import Icon from "../../fontIcons/icon";
import useResizer from "./../../services/useResizer";
import { MdOutlineContentCopy } from "react-icons/md";
import Tooltip from "@material-ui/core/Tooltip";
import Zoom from "@material-ui/core/Zoom";

export default function CryptoWithdrawDepositCard(props) {
  const isMobile = useResizer();

  const [openTooltip, setOpenTooltip] = useState(false);

  const statusDict = {
    FAILED: "REJECTED",
    IN_PROGRESS: "PENDING",
    AWAITING_ADMIN_ACTION: "PENDING",
    AWAITING_USER_VERIFICATION: "UNVERIFIED",
    APPROVED_BY_ADMIN: "SUCCESS",
    PROCESSED_BY_ADMIN: "SUCCESS",
    REJECTED_BY_ADMIN: "REJECTED",
  };

  function getSideText(side) {
    switch (side) {
      case "BUY":
        return (
          <div className="flex items-center justify-end">
            <span className="text-pb-primary-100 font-bold mr-1">Buy</span>
            <span className="text-gray-800 dark:text-gray-400 text-xs">
              {" "}
              Market
            </span>
          </div>
        );
      case "SELL":
        return (
          <div className="flex items-center justify-end">
            <span className="text-pb-primary-100 font-bold mr-1">Sell</span>
            <span className="text-gray-800 dark:text-gray-400 text-xs">
              {" "}
              Market
            </span>
          </div>
        );
      case "WITHDRAW":
        return (
          <div>
            <span className="text-pb-secondary-100 font-bold">Withdraw</span>
          </div>
        );
      case "DEPOSIT":
        return (
          <div>
            <span className="text-pb-primary-100 font-bold">Deposit</span>
          </div>
        );
    }
  }
  return (
    <div className="bg-gray-300 dark:bg-gray-900 p-5">
      <div className="flex justify-between">
        <div>
          <div className="flex items-center mb-3">
            {/* <Icon
              className="mr-2"
              icon={props.data.currency.toLowerCase()}
              size={26}
            /> */}
            <img
              src={props?.coinConfig?.activeIconUrl}
              height="auto"
              width={26}
              className="mr-3"
              alt={props.data.currency}
            />
            <p className="">{props.data.currency}</p>{" "}
          </div>
          {props.data.amount && (
            <div className=" mb-2">
              <div>{props.data.amount}</div>{" "}
              <div className="text-gray-800 dark:text-gray-400 text-xs mr-2">
                Amount
              </div>{" "}
            </div>
          )}
          <div className=" mt-5">
            <div className="break-all  w-[150px] mr-3">
              {props.data.address}
            </div>{" "}
            <div className="text-gray-800 dark:text-gray-400 text-xs mr-2">
              Address
            </div>{" "}
          </div>
          {/* {props.price && (
            <span className="flex items-center mb-2">
              <span className="text-gray-800 dark:text-gray-400 text-xs mr-2">
                Price
              </span>{" "}
              <span>₹{props.price}</span>
            </span>
          )} */}
          {/* {Boolean(props.totalAmount) && (
            <span className="flex items-center">
              <span className="text-gray-800 dark:text-gray-400 text-xs mr-2">
                Total
              </span>{" "}
              <span>₹{props.totalAmount}</span>
            </span>
          )} */}
        </div>
        <div className="flex flex-col justify-between text-right ">
          <div className="mb-2">{getSideText(props.data.side)}</div>
          {props.data.status == "SUCCESS" ? (
            <div>
              <div
                className={`flex items-start justify-end break-all  ${
                  isMobile ? "w-[150px]" : "w-[300px]"
                }`}
              >
                <div
                  className="mx-2 cursor-pointer"
                  onClick={() => {
                    navigator.clipboard.writeText(props.data.txnId);
                    setOpenTooltip(true);
                    setTimeout(() => {
                      setOpenTooltip(false);
                    }, 2000);
                  }}
                >
                  {props.data.txnId ? (
                    <Tooltip
                      open={openTooltip}
                      onOpen={() => setOpenTooltip(true)}
                      onClose={() => setOpenTooltip(false)}
                      title="Copied!"
                      placement="top"
                      disableFocusListener
                      disableHoverListener
                      disableTouchListener
                    >
                      <div>
                        <MdOutlineContentCopy size="18" />
                      </div>
                    </Tooltip>
                  ) : null}
                </div>
                <div>
                  {props.data.txnId ? props.data.txnId : "No TXid found"}
                </div>
              </div>
              <div className="text-gray-800 dark:text-gray-400 text-xs ">
                Transaction ID
              </div>
            </div>
          ) : null}
          <div>
            <div className="font-bold mb-2">
              {statusDict[props.data.status]}
            </div>

            <div className="text-gray-800 dark:text-gray-400 text-xs ">
              {props.data.modifiedAt
                ? format(
                    new Date(props.data.modifiedAt),
                    "dd.MM.yy, hh:mm:ss aaaaa'm'"
                  )
                : format(new Date(props.data.createdAt), "dd.MM.yy")}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
